import { all } from "redux-saga/effects";

import allBuyerSagas from "./allBuyers";
import crudBuyerSagas from "./crudBuyer";

export default function* ordersSagas() {
  yield all([allBuyerSagas(), crudBuyerSagas()]);
}
